<template>
  <vue-markdown v-bind="$attrs" v-on="$listeners" :class="classes">
    <slot />
  </vue-markdown>
</template>

<script>
import VueMarkdown from 'vue-markdown';
import Prism from 'prismjs';
import 'prismjs/components/prism-bash';
import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-css';
import 'prismjs/components/prism-markup';
import 'prismjs/components/prism-javascript';
import 'prismjs/components/prism-json';
import 'prismjs/components/prism-json5';
import 'prismjs/plugins/toolbar/prism-toolbar';
import 'prismjs/plugins/toolbar/prism-toolbar.css';
import 'prismjs/plugins/show-language/prism-show-language';
import 'prismjs/plugins/line-numbers/prism-line-numbers';
import 'prismjs/plugins/line-numbers/prism-line-numbers.css';
import 'prismjs/plugins/inline-color/prism-inline-color';
import 'prismjs/plugins/inline-color/prism-inline-color.css';
import 'prismjs/themes/prism-okaidia.min.css';

export default {
  name: 'Markdown',
  inheritAttrs: false,
  components: {
    VueMarkdown,
  },
  props: {
    syntaxHighlighting: {
      type: Boolean,
      default: true,
    },
    showLineNumbers: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    if (this.syntaxHighlighting) {
      this.$nextTick(() => Prism.highlightAll());
    }
  },
  computed: {
    classes() {
      return {
        'line-numbers': this.showLineNumbers,
      }
    },
  },
};
</script>

<style lang="scss" scoped>
>>> {
  code[class*=language-] {
    background: none !important;
  }

  h1, h2, h3, h4, h5, h6, .code-toolbar {
    margin: 18px 0 15px;
  }
}
</style>
